module.exports = __webpack_public_path__ + "d9f0e0dedc5648c22d17fa485791b3ef.svg";